import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import auth from 'Auth/authenticator';
import { AppSettings } from '../../constants';
import InputEditAble from 'components/inputEditAble';
import HomeDocumentSection from '../Components/Document/home-document-section';
import * as ProjectActionType from '../constants';

class ProjectAddEditHomeDocument extends Component {
  static propTypes = {
    projectId: PropTypes.any,
    projectDocumentTypeId: PropTypes.any,
    dispatch: PropTypes.func,
    DocumentTypes: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      itemEdit: null
    };
  }

  componentDidMount() {
    this.fetchListDocumentType();
  }

  fetchListDocumentType = () => {
    const { projectId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.GET_LIST_PROJECT_DOCUMENT_TYPE_ASYNC,
      params: {
        projectId
      }
    });
  };

  onEditTabName = item => {
    this.setState({
      itemEdit: item
    });
  };

  onSelectTab = (key, e) => {
    if (
      (document.getElementById(key) &&
        !document.getElementById(key).contains(e.target)) ||
      !document.getElementById(key)
    ) {
      this.setState({ activeKey: key });
    }
  };

  onCancelEdit = () => {
    this.setState({
      itemEdit: null
    });
  };

  onUpdateTabName = param => {
    const { projectId } = this.props;

    const { itemEdit } = this.state;

    this.props.dispatch({
      type: ProjectActionType.UPDATE_HOMEOWNER_MANUAL_FOLDER_TITLE_ASYNC,
      params: {
        projectId,
        documentTypeId: itemEdit.value,
        data: param
      },
      callback: this.onCancelEdit
    });
  };

  render() {
    const { projectId, DocumentTypes } = this.props;

    const { activeKey, itemEdit } = this.state;

    const roleName = auth.getRoleName();

    const isAllowedEditTabName =
      roleName === AppSettings.BUILDER_SUPER_ADMIN ||
      roleName === AppSettings.BUILDER_ADMIN;

    return (
      <div className='project-document-wrapper'>
        <div>
          <Tab.Container
            id='left-tabs-example'
            className='s1-stack-tab'
            activeKey={activeKey}
            onSelect={this.onSelectTab}
          >
            <Row className='clearfix'>
              <Col sm={2} style={{ paddingRight: 0 }}>
                <div className='project-documents-group-tabs-title'>
                  Documents
                </div>
                <Nav bsStyle='pills' stacked>
                  {DocumentTypes.filter(
                    x => x.extensionValue.documentType === 0
                  ).map(type => {
                    const typeIndex = DocumentTypes.indexOf(type);

                    if (itemEdit && itemEdit.value === type.value) {
                      return (
                        <InputEditAble
                          defaultValue={type.text}
                          maxLength='450'
                          inputName='name'
                          className='tab-input'
                          autoFocus
                          onSubmit={this.onUpdateTabName}
                          onCancel={this.onCancelEdit}
                        />
                      );
                    }

                    return (
                      <NavItem
                        eventKey={typeIndex.toString()}
                        key={typeIndex}
                        className={
                          itemEdit && itemEdit.value === type.value
                            ? 'document-nav-tab document-nav-tab-edit'
                            : 'document-nav-tab'
                        }
                      >
                        {type.text}
                        {isAllowedEditTabName && (
                          <span
                            id={typeIndex.toString()}
                            className='fa fa-pencil tab-title-edit-icon'
                            style={{ color: '#4a4a4a', marginLeft: 5 }}
                            onClick={() => this.onEditTabName(type)}
                          />
                        )}
                      </NavItem>
                    );
                  })}
                </Nav>
                <div
                  className='project-documents-group-tabs-title'
                  style={{ marginTop: 40 }}
                >
                  Videos
                </div>
                <Nav bsStyle='pills' stacked>
                  {DocumentTypes.filter(
                    x => x.extensionValue.documentType === 1
                  ).map(type => {
                    const typeIndex = DocumentTypes.indexOf(type);

                    if (itemEdit && itemEdit.value === type.value) {
                      return (
                        <InputEditAble
                          defaultValue={type.text}
                          maxLength='450'
                          inputName='name'
                          className='tab-input'
                          autoFocus
                          onSubmit={this.onUpdateTabName}
                          onCancel={this.onCancelEdit}
                        />
                      );
                    }

                    return (
                      <NavItem
                        eventKey={typeIndex.toString()}
                        key={typeIndex}
                        className={
                          itemEdit && itemEdit.value === type.value
                            ? 'document-nav-tab document-nav-tab-edit'
                            : 'document-nav-tab'
                        }
                      >
                        {type.text}
                        {isAllowedEditTabName && (
                          <span
                            id={typeIndex.toString()}
                            className='fa fa-pencil tab-title-edit-icon'
                            style={{ color: '#4a4a4a', marginLeft: 5 }}
                            onClick={() => this.onEditTabName(type)}
                          />
                        )}
                      </NavItem>
                    );
                  })}
                </Nav>
              </Col>
              <Col sm={10}>
                <Tab.Content
                  animation
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    border: '1px solid #e6e6e6',
                    backgroundColor: '#fff',
                    minHeight: 255
                  }}
                >
                  {DocumentTypes.map((type, index) => {
                    return (
                      <Tab.Pane eventKey={index.toString()} key={index}>
                        <HomeDocumentSection
                          hidden={activeKey !== index.toString()}
                          projectId={projectId}
                          documentTypeId={type.value}
                          manualType={type.extensionValue.documentType}
                        />
                      </Tab.Pane>
                    );
                  })}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    DocumentTypes: state.ProjectStore.DocumentTypes
  };
};

export default connect(mapStateToProps)(ProjectAddEditHomeDocument);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-home-document.js